export const monthsNoDataXaxis = {
  dashboardAprilToSeptember: [
    {
      name: 'July',
    },
    {
      name: 'August',
    },
    {
      name: 'September',
    },
  ],
  dashboardOctoberToMarch: [
    {
      name: 'October',
    },
    {
      name: 'November',
    },
    {
      name: 'December',
    },
    {
      name: 'January',
    },
    {
      name: 'February',
    },
    {
      name: 'March',
    },
  ],
};
